













import { Component, Vue } from "vue-property-decorator";
import {
  dateFormat,
  convertToDate,
  dateRangeValues,
  currencyColor,
  getYAxisWithCurrency,
  getTooltipFormattedLabel
} from "@/components/app/global/stats/charts/utils";

@Component({
  components: {
    "date-range-chart": () =>
      import("@/components/app/global/stats/charts/_dateRangeChart.vue")
  }
})
export default class RevenueChart extends Vue {
  public get config() {
    return {
      normalized: true,
      plugins: { tooltip: { callbacks: { label: getTooltipFormattedLabel } } },
      scales: { y: { ticks: { callback: getYAxisWithCurrency } } }
    };
  }

  public getChartData({ data, params, dates, currencyCode, currency }) {
    const statData = data || { [currencyCode]: [] };
    const result: any[] = [currencyCode].map((currencyCodeData, index) => {
      const existingDates = this.$_.get(statData, currencyCodeData, []).map(i =>
        this.$moment(convertToDate(i.year, i.day, i.hour))
      );

      const format = dateFormat(params.group, dates);

      const mappedData = dateRangeValues(
        params.group,
        dates,
        existingDates,
        statData[currencyCodeData] || [],
        (item, date) => ({
          // Mapped chart data
          value: this.$_.get(item, "total_amount", 0),
          valueFormatted: this.$_.get(item, "total_amount_formatted", "0"),
          date: date.format(format)
        })
      );

      const color = currencyColor({ index, currencyCodeData });

      return {
        labels: mappedData.map(i => i.date),
        dataset: {
          currency,
          label:
            currency && currencyCodeData !== currency.code
              ? `${currencyCodeData} (${currency.code})`
              : currencyCodeData,
          borderColor: color.borderColor,
          backgroundColor: color.backgroundColor,
          data: mappedData.map(i => i.value),
          mappedData // injecting here to use in the tooltip function
        }
      };
    });

    return {
      labels: result[0].labels,
      datasets: result.map(i => i.dataset)
    };
  }
}
